import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Figure } from "@/components/bloks/Media/components/Figure";
import { Container } from "@/components/ui/Container";
import { Typography } from "@/components/ui/Typography";
import type { DualMediaTextStoryblok } from "@/generated/sb/sb-types";

export const DualMediaTextBlok = ({ blok }: BlokProps<DualMediaTextStoryblok>) => {
	const Content = () => {
		return (
			<div className="grid grid-cols-4 gap-grid-component-spacing-md md:grid-cols-2 md:grid-rows-2">
				<div className="col-span-4 row-start-1 flex flex-col gap-grid-component-spacing-sm md:col-span-1 md:col-start-1 md:row-start-1 md:max-w-[512px] md:self-start ">
					{blok.label && (
						<Typography variant="label-sm-reg" as="p" className="text-text-dark-text-1">
							{blok.label}
						</Typography>
					)}
					{blok.title && (
						<Typography variant="heading-display-sm" as="h3" className="text-text-dark-text-1">
							{blok.title}
						</Typography>
					)}
					{blok.description && (
						<Typography
							variant="body-sm-reg"
							as="p"
							className="text-text-dark-text-1 leading-[1.5]"
						>
							{blok.description}
						</Typography>
					)}
				</div>

				{blok.asset1 && (
					<Figure
						asset={blok.asset1}
						containerClassName="col-span-4 row-start-2 md:col-span-1 md:col-start-1 md:row-start-2 md:self-end"
						mediaClassName="aspect-3/2"
					/>
				)}
				{blok.asset2 && (
					<Figure
						asset={blok.asset2}
						containerClassName="col-span-4 row-start-3 md:col-span-1 md:col-start-2 md:row-span-2 md:row-start-1 md:h-full"
						mediaClassName="aspect-3/4 md:aspect-auto md:min-h-0 md:flex-1"
					/>
				)}
			</div>
		);
	};
	return (
		<BlokWrap editable={blok} className="pb-grid-section-vertical-md">
			{blok.fullWidth ? (
				<Content />
			) : (
				<Container>
					<Content />
				</Container>
			)}
		</BlokWrap>
	);
};
